import {Controller, ControllerProps, FieldPath, FieldValues, ValidationRule} from 'react-hook-form';
import AppCheckbox, {AppCheckboxProps} from './AppCheckbox';
import {Typography} from '@mui/material';

export type AppControlledCheckboxProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<AppCheckboxProps, 'name' | 'required'> &
    Omit<ControllerProps<TFieldValues, TName>, 'render'> & {
        errorMessage?: string;
        required?: string | ValidationRule<boolean>;
    };

export function AppControlledCheckbox<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({name, control, rules, value, required, errorMessage, ...rest}: AppControlledCheckboxProps<TFieldValues, TName>) {
    return (
        <>
            <Controller
                name={name}
                rules={{required: required, ...rules}}
                control={control}
                {...rest}
                render={({field: {value, onChange, ...restFields}, fieldState: {invalid, error}}) => {
                    return (
                        <>
                            <AppCheckbox
                                {...rest}
                                {...restFields}
                                checked={value ?? false}
                                value={value ?? false}
                                onChange={e => {
                                    onChange(e);
                                    if (rest.onChange) rest.onChange(e, e.target.checked);
                                }}
                            />

                            {invalid && error?.message && (
                                <Typography variant="caption" color="error">
                                    {error?.message}
                                </Typography>
                            )}
                        </>
                    );
                }}
            />
        </>
    );
}

export default AppControlledCheckbox;
